module.exports = __webpack_public_path__ + "9e0d8c38f9f75b3a664e4f5c4ec4e719.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C0000B70Y.png
// module id = 1715
// module chunks = 0